exports.Routes = {
  EditorPage: (query) => ({ pathname: "/[slug]/editor/[[...editorParams]]", query }),
  OrgHome: (query) => ({ pathname: "/[slug]", query }),
  NewOrgPage: (query) => ({ pathname: "/new", query }),
  NotionPage: (query) => ({ pathname: "/notion/[orgSlug]/[pageId]", query }),
  Page404: (query) => ({ pathname: "/404", query }),
  Converter: (query) => ({ pathname: "/assetTransferToNotifyConverter", query }),
  Home: (query) => ({ pathname: "/", query }),
  TestErr: (query) => ({ pathname: "/testerr", query })
}